import ResetTempPasswordView from './reset-temp-password-view';

export default ResetTempPasswordView;
